export enum ProductType {
  LABEL = 'LABEL',
  STRING = 'STRING',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',

  ADDRESS = 'ADDRESS',
  PORTING = 'PORTING',
  PHONE_NUMBER = 'PHNUMBER',
  CONTRACTED_SERVICE = 'CONTRACTEDSERVICE',
  GROUP_LIMIT = 'GROUPLIMIT',
  SIM_NUMBER = 'SIMNUMBER',
  DROPDOWN = 'DROPDOWN',
  SUB_ARRAY = 'SUBARRAY', // used for extra items
}
